export default {
  methods: {
    /**
     * Скрыть элементы которые не нужны при печати
     * @returns void
     */
    hideWhenPrintElement() {
      const unNeedingBlocks = document.getElementById('update-button');
      unNeedingBlocks.style.setProperty('visibility', 'hidden');
    },
    /**
     * Показать элементы которые не нужны при печати
     * @returns void
     */
    showNotWhenPrintElement() {
      const unNeedingBlocks = document.getElementById('update-button');
      unNeedingBlocks.style.setProperty('visibility', 'visible');
    },
  },
};
